import { Injectable } from '@angular/core';
import { MatTimepicker, MatTimepickerOption } from '@angular/material/timepicker';

@Injectable({
  providedIn: 'root',
})
export class TimepickerUtilitiesService {
  public generateTimeOptions(): MatTimepickerOption<Date>[] {
    return Array.from({ length: 48 }, (_, i) => {
      const optionTime = new Date();
      optionTime.setHours(0, i * 30, 0, 0);

      return {
        label: optionTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }),
        value: optionTime,
      };
    });
  }

  public filterTimeOptions(
    inputValue: string,
    allTimeOptions: MatTimepickerOption<Date>[],
  ): MatTimepickerOption<Date>[] {
    const lowerCaseInput = inputValue.toLowerCase();

    return allTimeOptions.filter((option) => option.label.toLowerCase().includes(lowerCaseInput));
  }

  public handleTimePickerInputChange(
    event: Event,
    timepicker: MatTimepicker<Date>,
    filteredOptions: MatTimepickerOption<Date>[],
    allTimeOptions: MatTimepickerOption<Date>[],
  ): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement?.value || '';

    const updatedOptions = this.filterTimeOptions(inputValue, allTimeOptions);
    filteredOptions.splice(0, filteredOptions.length, ...updatedOptions);

    timepicker.close();
    setTimeout(() => timepicker.open());
  }
}
